/**
 * Dropdown menu component type definitions
 */

export enum DropdownMenuSize {
  Small = 'sm',
  Default = 'default',
}

export enum DropdownMenuItemVariant {
  Default = 'default',
  Destructive = 'destructive',
  Success = 'success',
}
